import { TlfItemIndexReadDto } from "functions/api/tlfItem/TlfItemIndexReadDto";
import { HierarchyTlfSelection } from "./interface";

/**
 * Builds a report selection from available outputs and the latest source metadata.
 *
 * @param item - Current persisted source summary
 * @param includeMaster - Whether to include the source's unpatched output
 * @param variantNames - Requested named outputs, excluding any no longer available
 * @returns A refreshed selection, or an empty list when no requested outputs remain
 */
export const getReportTlfSelection = (
  item: TlfItemIndexReadDto,
  includeMaster: boolean,
  variantNames: string[],
): HierarchyTlfSelection[] => {
  const variants = (item.variantTemplates ?? []).filter((variant) =>
    variantNames.includes(variant.name),
  );
  const domains = [
    ...(includeMaster ? [item.domain] : []),
    ...variants.map((variant) => variant.domain ?? item.domain),
  ];
  return domains.length === 0
    ? []
    : [
        {
          azsolId: item.azsolId,
          // TODO: Can domain be removed from HierarchyTlfSelection
          // Retain any invalid selected domain so group validation cannot hide an invalid output.
          domain: domains.find((domain) => !domain || domain === "BL") ?? domains[0],
          id: item.id,
          includeMaster,
          variantNames: variants.map((variant) => variant.name),
          version: item.version,
        },
      ];
};
